import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDownRounded';
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUpRounded';
import OpenInNew from '@mui/icons-material/OpenInNewRounded';
import { Box, Button, Typography, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Navigation } from './Header';
import { ATCOPaletteColor } from '../../theme/ATCOPaletteColor';
import { TypographyVariants } from '../../theme/TypographyVariants';

interface HeaderMenuProps {
    navobj: Navigation[];
    searchButtonClicked: boolean;
    handleMainMenuClick: (child: Navigation) => void;
    mainMenuclicked: boolean;
    menuItem: string;
}

const useStyles = makeStyles((theme) => ({
    root: {
        marginLeft: '16px',
        height: '56px',
        display: 'flex',
        flexGrow: '1',
    },
}));

const HeaderMenu: React.FC<HeaderMenuProps> = (props: HeaderMenuProps) => {
    const classes = useStyles();

    const { navobj, searchButtonClicked, handleMainMenuClick, mainMenuclicked, menuItem } = props;

    const MAX_HEADER_MENU_CHARACTERS = 50;

    const calculateMenuItems = (): number => {
        let charCount = 0;
        let menuItemCount = 0;
        // eslint-disable-next-line no-plusplus
        for (let index = 0; index < navobj.length; index++) {
            if (charCount > MAX_HEADER_MENU_CHARACTERS) {
                break;
            }
            charCount += navobj[index].navText.length;
            menuItemCount = index;
        }

        return menuItemCount;
    };

    return (
        <Box className={classes.root}>
            {navobj.map((firstLevelNavItem: Navigation) => {
                return (
                    // searchButtonClicked && index > calculateMenuItems() ? null :
                    <Button
                        aria-label={firstLevelNavItem.navText}
                        key={firstLevelNavItem.navText}
                        onClick={() => {
                            handleMainMenuClick(firstLevelNavItem);
                        }}
                        sx={{
                            marginRight: '8px',
                            color: mainMenuclicked && menuItem === firstLevelNavItem.navText ? ATCOPaletteColor.primary2Tint4 : ATCOPaletteColor.white,
                            paddingTop: mainMenuclicked && menuItem === firstLevelNavItem.navText ? '1.65rem' : '1.75rem',
                            paddingBottom: mainMenuclicked && menuItem === firstLevelNavItem.navText ? '1.65rem' : '1.75rem',
                            borderBottomColor: mainMenuclicked && menuItem === firstLevelNavItem.navText ? ATCOPaletteColor.primary2Tint4 : null,
                            borderBottomStyle: mainMenuclicked && menuItem === firstLevelNavItem.navText ? 'solid' : null,
                            borderBottomWidth: mainMenuclicked && menuItem === firstLevelNavItem.navText ? '0.25rem' : null,
                            '&:hover': {
                                color: ATCOPaletteColor.primary2Tint4,
                                paddingTop: '1.65rem',
                                paddingBottom: '1.65rem',
                                borderBottomColor: ATCOPaletteColor.primary2,
                                width: 'fit-content',
                                borderBottomStyle: 'solid',
                                borderBottomWidth: '0.25rem',
                            },
                        }}
                    >
                        <Typography variant={TypographyVariants.overlineUppercase}>{firstLevelNavItem.navText}</Typography>
                        {!firstLevelNavItem.external && firstLevelNavItem.child && mainMenuclicked && menuItem === firstLevelNavItem.navText ? (
                            <KeyboardArrowUp sx={{ width: '16px', height: '16px', marginLeft: '4px' }} />
                        ) : !firstLevelNavItem.external && firstLevelNavItem.child ? (
                            <KeyboardArrowDown sx={{ width: '16px', height: '16px', marginLeft: '4px' }} />
                        ) : (
                            firstLevelNavItem.external && (
                                <OpenInNew
                                    sx={{
                                        width: '16px',
                                        height: '16px',
                                        marginLeft: '4px',
                                    }}
                                />
                            )
                        )}
                    </Button>
                );
            })}
        </Box>
    );
};

export default HeaderMenu;
